import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { GlobalSettingsIssuesSidebar as GlobalIssuesSettingsSidebarType } from './ui/index.tsx';

const LazyGlobalIssuesSettingsSidebar = lazyAfterPaint<typeof GlobalIssuesSettingsSidebarType>(
	() => {
		setPerformanceMarkLoadStart();
		return import(/* webpackChunkName: "async-sidebar-global-settings-issues" */ './index').then(
			(bundle) => {
				setPerformanceMarkLoadEnd();
				return bundle;
			},
		);
	},
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GlobalIssuesSettingsSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="globalIssuesSettings">
		<LazyGlobalIssuesSettingsSidebar />
	</SidebarBoundary>
));

export default GlobalIssuesSettingsSidebar;
